import React from "react";
import LegalDocumentLayout from "./LegalDocumentLayout";

export default function PrivacyPage() {
  return (
    <LegalDocumentLayout title="Política de Privacidade" updatedAt="15 de junho de 2026">
      <p>
        Esta Política de Privacidade descreve como a <strong>Xvision Tecnologia</strong> (“Xvision”,
        “nós”) trata dados pessoais no uso da plataforma <strong>XPro</strong>, acessível em{" "}
        <strong>xpro4.xpro.me</strong> e domínios relacionados (“Plataforma”). Informações institucionais
        sobre a Xvision estão em{" "}
        <a href="https://xvisiontecnologia.com.br" target="_blank" rel="noopener noreferrer">
          xvisiontecnologia.com.br
        </a>
        .
      </p>
      <p>
        Ao utilizar a Plataforma, você declara ter lido esta Política. Em caso de dúvidas, entre em
        contato pelo e-mail{" "}
        <a href="mailto:privacidade@xpro.me">privacidade@xpro.me</a>.
      </p>

      <h2>1. Quem somos (controlador)</h2>
      <p>
        A Xvision Tecnologia é responsável pelo tratamento de dados pessoais relacionados ao cadastro,
        autenticação, operação e suporte da Plataforma XPro, nos termos da Lei nº 13.709/2018 (LGPD).
      </p>

      <h2>2. Dados que coletamos</h2>
      <p>Podemos tratar, conforme o uso da Plataforma:</p>
      <ul>
        <li>
          <strong>Dados de cadastro e conta:</strong> nome, e-mail, telefone, cargo, foto, preferências
          de idioma e tema, credenciais de acesso e registros de autenticação.
        </li>
        <li>
          <strong>Dados operacionais:</strong> conversas, solicitações, clientes, tarefas, compromissos
          de agenda, anexos, metadados de uso e logs técnicos (IP, navegador, data/hora de acesso).
        </li>
        <li>
          <strong>Integrações opcionais:</strong> quando você conecta serviços de terceiros (por exemplo,
          Google Agenda), tratamos tokens OAuth, identificadores de sincronização e eventos necessários
          à funcionalidade escolhida.
        </li>
        <li>
          <strong>Comunicações:</strong> mensagens de suporte, notificações por e-mail ou canais
          configurados pelo seu workspace.
        </li>
      </ul>

      <h2>3. Google Agenda (integração opcional)</h2>
      <p>
        Se você optar por conectar sua conta Google Agenda em Meu Perfil, solicitamos permissões para
        ler e gravar <strong>eventos de calendário</strong> e identificar seu <strong>e-mail Google</strong>,
        exclusivamente para sincronizar compromissos criados manualmente no XPro com sua agenda Google.
      </p>
      <ul>
        <li>A sincronização ocorre somente quando você ativa a integração.</li>
        <li>
          Prazos de tarefas e próximos contatos de solicitações permanecem apenas no XPro, salvo ação
          manual sua.
        </li>
        <li>
          Você pode desconectar a integração a qualquer momento em Meu Perfil; tokens associados são
          revogados ou descartados conforme aplicável.
        </li>
        <li>
          O tratamento de dados pelo Google também se submete à{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Política de Privacidade do Google
          </a>
          .
        </li>
      </ul>

      <h2>4. Finalidades e bases legais</h2>
      <p>Utilizamos os dados para:</p>
      <ul>
        <li>Prestar, manter e melhorar a Plataforma (execução de contrato e legítimo interesse).</li>
        <li>Autenticar usuários, garantir segurança e prevenir fraudes (legítimo interesse e obrigação legal).</li>
        <li>Processar integrações solicitadas por você (execução de contrato e consentimento, quando exigido).</li>
        <li>Cumprir obrigações legais e responder a solicitações de autoridades.</li>
        <li>Enviar comunicações operacionais e, quando permitido, informativos sobre o serviço.</li>
      </ul>

      <h2>5. Compartilhamento</h2>
      <p>Podemos compartilhar dados com:</p>
      <ul>
        <li>
          <strong>Provedores de infraestrutura</strong> (hospedagem, e-mail, armazenamento, filas),
          sob contratos e medidas de segurança compatíveis com a LGPD.
        </li>
        <li>
          <strong>Integrações habilitadas pelo usuário ou administrador do workspace</strong> (ex.:
          Google, Meta, WhatsApp, telefonia), conforme configuração e autorização.
        </li>
        <li>
          <strong>Autoridades públicas</strong>, quando houver base legal ou ordem válida.
        </li>
      </ul>
      <p>Não vendemos dados pessoais.</p>

      <h2>6. Retenção</h2>
      <p>
        Mantemos os dados pelo tempo necessário às finalidades descritas, à execução contratual, ao
        cumprimento de obrigações legais e à resolução de disputas. Após o encerramento da conta ou
        solicitação válida, adotamos procedimentos de eliminação, anonimização ou bloqueio, conforme
        aplicável.
      </p>

      <h2>7. Segurança</h2>
      <p>
        Adotamos medidas técnicas e organizacionais proporcionais ao risco, incluindo controle de
        acesso, criptografia em trânsito, segregação por workspace (tenant) e monitoramento. Nenhum
        sistema é totalmente isento de riscos; recomendamos senhas fortes e uso de autenticação
        adicional quando disponível.
      </p>

      <h2>8. Seus direitos (LGPD)</h2>
      <p>Você pode solicitar, conforme a LGPD:</p>
      <ul>
        <li>Confirmação de tratamento e acesso aos dados.</li>
        <li>Correção de dados incompletos, inexatos ou desatualizados.</li>
        <li>Anonimização, bloqueio ou eliminação de dados desnecessários ou tratados em desconformidade.</li>
        <li>Portabilidade, quando aplicável.</li>
        <li>Informação sobre compartilhamentos e revogação de consentimento.</li>
        <li>Oposição a tratamentos baseados em legítimo interesse, quando cabível.</li>
      </ul>
      <p>
        Envie solicitações para{" "}
        <a href="mailto:privacidade@xpro.me">privacidade@xpro.me</a>. Podemos solicitar informações
        adicionais para confirmar sua identidade.
      </p>

      <h2>9. Cookies e tecnologias similares</h2>
      <p>
        Utilizamos cookies e armazenamento local essenciais para sessão, preferências e segurança.
        Ferramentas analíticas ou de marketing, quando utilizadas, serão informadas de forma
        complementar ou mediante consentimento quando exigido.
      </p>

      <h2>10. Transferência internacional</h2>
      <p>
        Alguns provedores (incluindo Google) podem processar dados fora do Brasil. Nesses casos,
        buscamos garantias contratuais e mecanismos compatíveis com a LGPD.
      </p>

      <h2>11. Alterações</h2>
      <p>
        Esta Política pode ser atualizada periodicamente. A data da última revisão constará no topo
        desta página. Alterações relevantes poderão ser comunicadas por meios razoáveis (e-mail ou
        aviso na Plataforma).
      </p>

      <h2>12. Contato</h2>
      <p>
        Controlador: Xvision Tecnologia — Plataforma XPro
        <br />
        E-mail: <a href="mailto:privacidade@xpro.me">privacidade@xpro.me</a>
        <br />
        Site institucional:{" "}
        <a href="https://xvisiontecnologia.com.br">https://xvisiontecnologia.com.br</a>
        <br />
        Aplicação XPro: <a href="https://xpro4.xpro.me">https://xpro4.xpro.me</a>
      </p>
    </LegalDocumentLayout>
  );
}
